// extracted by mini-css-extract-plugin
module.exports = {"switchButton":"DirectionsForm_switchButton__37-99"};